const app = document.getElementById('app');

// Identify if site is mobile or not
const mediaQuery = '(max-width: 991px)';
const mediaQueryList = window.matchMedia(mediaQuery);

// mediaQueryList.addEventListener('change', event => {
//     console.log(window.innerWidth);
//   if (event.matches) {
//     console.log('The window is now 700px or under');
//   } else {
//     console.log('The window is now over 700px');
//   }
// })

const closeActiveDrawers = () => {
  const activeDrawers = document.querySelectorAll('.drawer._open');
  Array.from(activeDrawers).forEach(d => {
    toggleDrawer(d, false);
  });
}

const toggleDrawer = (drawer, show) => {
  drawer = drawer.nodeType ? drawer : document.getElementById(drawer);
  // show is undefined by default, so if not passed, toggle inverts the active state.
  // ...but, figure out which one it is anyway so we can do other things. So much for elegance.
  const drawerWasOpen = drawer.classList.contains('_open');

  let opening = !drawerWasOpen; // if it's not open currently, it'll toggle open, so it's opening
  if (typeof show !== 'undefined') {
    opening = opening && show; // unless show is false
  }

  drawer.classList.toggle('_open', show);

  const drawerNowOpen = drawer.classList.contains('_open');
  // Look into a function that stores the focus for redirects and popups
  window.previouslyFocusedElement;

  if (drawerNowOpen === true) {
    window.previouslyFocusedElement = document.activeElement;
    drawer.tabIndex = 0;
    drawer.removeAttribute('inert')
    drawer.focus();
  } else {
    drawer.tabIndex = -1;
    drawer.setAttribute('inert', '')
    if (window.previouslyFocusedElement) {
      window.previouslyFocusedElement.focus();
    }
  }

  window.overlayFunctions.overlayToggleMobile(drawerNowOpen, closeActiveDrawers);

  const isMobile = mediaQueryList.matches;
  if (isMobile) {
    if (opening) {
      freezeSite(app);
      return drawerNowOpen;
    }
    thawSite(app);
    return drawerNowOpen;
  }

  // Return current state of the drawer for state-sensitive callers
  return drawerNowOpen;
};

const toggleDrawerHandler = (e, show) => {
  let drawerID;
  try {
    drawerID = e.target.dataset.target;
  } catch(err) {
    console.log(err);
  }
  const drawer = drawerID ? document.getElementById(`${ drawerID }`) : e.target.closest('.drawer');

  if (!drawer) {
    console.warn('no drawer to target', e.target);
    return;
  }

  toggleDrawer(drawer, show);
}

const freezeSite = (el = document.body) => {
  // console.log('freezeSite', el);

  // If already frozen, don't do anything
  const frozen = el.classList.contains('_freeze');
  if (frozen) {
    return;
  }

  const verticalPosition = document.documentElement.scrollTop;
  el.setAttribute('data-vpos', verticalPosition);
  el.classList.add('_freeze');
  el.style.top = `-${ verticalPosition }px`;

  if (el.id === 'app') {
    // Have to work with Vue if that's the element we're targeting
    window.freezeApp(true, verticalPosition);  
  }
}

const thawSite = (el = document.body) => {
  // console.log('thawSite', el);
  const frozen = el.classList.contains('_freeze');
  if (!frozen) {
    return;
  }

  const verticalPosition = el.dataset.vpos;

  el.removeAttribute('data-vpos');
  el.classList.remove('_freeze');
  el.style.top = '';

  if (!verticalPosition) {
    return;
  }

  if (el.id === 'app') {
    // Have to work with Vue if that's the element we're targeting
    window.freezeApp(false);
  }

  document.documentElement.scrollTop = verticalPosition;
}

// document.addEventListener('DOMContentLoaded', async () => {
//   window.overlayFunctions.overlayAttachClick(closeActiveDrawers);
// });

window.drawerFunctions = {
  toggleDrawer: toggleDrawer,
  toggleDrawerHandler: toggleDrawerHandler,
  closeActiveDrawers: closeActiveDrawers,
};

window.themeUtils = window.themeUtils || {};
window.themeUtils.freezeSite = freezeSite;
window.themeUtils.thawSite = thawSite;
